import styles from './Header.module.css';
import HeaderButton from "./objects/HeaderButton";
import HeaderLogo from "./objects/HeaderLogo";
import AccountHeader from "./objects/AccountHeader";
import React, {useEffect, useState} from "react";
import {getSubDomain} from "@/commons/utils/Domains";
import DropdownMenu from "@/commons/utils/Dropdown/DropdownMenu";
import DropdownElement from "@/commons/utils/Dropdown/DropdownElement";
import Redirects from "@/commons/utils/Redirects";
import FileHandler from "@/www/pages/server/objects/file/FileHandler";


import {DirectoryIcon, FileIcon, TicketIcon, UserIcon} from "@/commons/resources/images/AdminIcons";
import Sections from "@/admin/sections/Sections";

const Header = () => {
    const [servers, setServers] = useState([]);

    useEffect(() => {
        let isMounted = true;

        const loadServers = async () => {
            const files = await FileHandler.getFileList();
            const loadedServers = [];

            for (const fileName of files) {
                const fileData = await FileHandler.loadFile(fileName);
                loadedServers.push(fileData.title);
            }

            if (isMounted) setServers(loadedServers);
        };

        loadServers();

        return () => {
            isMounted = false; // cleanup sicuro
        };
    }, []);

    const helpDropdown = () => (
        <DropdownMenu title={<HeaderButton title={"AIUTO"}/>} char={""} align="right">
            <div className={styles.customDropdownGridContainer}>
                <div className={styles.customDropdownGrid}>
                    <div className={styles.customDropdownGridItem}>
                        <h4>AIUTO</h4>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("www", "faq", e)}>
                            FAQ
                        </DropdownElement>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("www", "tos", e)}>
                            TOS
                        </DropdownElement>
                    </div>
                    <div className={styles.customDropdownGridItem}>
                        <h4>SERVER</h4>
                        <DropdownElement>
                            Come entrare <span className={styles.smallText}>SOON</span>
                        </DropdownElement>
                        <DropdownElement>
                            Guide <span className={styles.smallText}>SOON</span>
                        </DropdownElement>
                    </div>
                </div>
                <div className={styles.customDropdownGrid}>
                    <div className={styles.customDropdownGridItem}>
                        <h4>REPORT</h4>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("reports", "", e)}>
                            Sito report
                        </DropdownElement>
                        <DropdownElement removeHover={true} onClick={() => {}}>&nbsp;</DropdownElement>
                    </div>
                    <div className={styles.customDropdownGridItem}>
                        <h4>ALTRO</h4>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("www", "social", e)}>
                            Socials
                        </DropdownElement>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("www", "tos", e)}>
                            Privacy
                        </DropdownElement>
                    </div>
                </div>
            </div>
        </DropdownMenu>
    )

    const serverDropdown = () => (
        <DropdownMenu title={<HeaderButton title={"SERVER"}/>} char={""} align="left">
            <div className={styles.customDropdownGridContainer}>
                <div className={styles.customDropdownGrid}>
                    <div className={styles.customDropdownGridItem}>
                        <h4>SERVER</h4>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("www", "history", e)}>
                            La Storia
                        </DropdownElement>
                        <DropdownElement>
                            Lo Staff <span className={styles.smallText}>SOON</span>
                        </DropdownElement>
                    </div>
                    <div className={styles.customDropdownGridItem}>
                        <h4>MODALITÀ</h4>
                        {servers?.map((title) => (
                            <DropdownElement onClick={(e) => Redirects.domainSendClick("www", "server/"+title, e)}>
                                {title}
                            </DropdownElement>
                        ))}
                    </div>
                </div>
                <div className={styles.customDropdownGrid}>
                    <div className={styles.customDropdownGridItem}>
                        <h4>MAPPE</h4>
                        <DropdownElement onClick={(e) => Redirects.send("https://www.eblcraft.it/map/mondo1/", e)}>
                            Vanilla Mondo 1
                        </DropdownElement>
                        <DropdownElement onClick={(e) => Redirects.send("https://www.eblcraft.it/map/mondo2/", e)}>
                            Vanilla Mondo 2
                        </DropdownElement>
                    </div>
                    <div className={styles.customDropdownGridItem}>
                        <h4>SERVIZI</h4>
                        <DropdownElement onClick={(e) => Redirects.send("https://status.eblcraft.it/status/eblcraft", e)}>
                            Status
                        </DropdownElement>

                        <h4>ALTRO</h4>
                        <DropdownElement onClick={(e) => Redirects.domainSendClick("www", "erenblaze", e)}>
                            ErenBlaze
                        </DropdownElement>
                    </div>
                </div>
            </div>
        </DropdownMenu>
    )

    const webNavbar = () => (
        <>
            {serverDropdown()}
            <HeaderButton title={"STORE"} link={"https://store.eblcraft.it"}/>
            <div className={styles.headerSpacerButton}/>
            <HeaderButton title={"ERENBLAZE"} link={"/erenblaze"}/>
            {helpDropdown()}
        </>
    );

    const reportsNavbar = () => (webNavbar());

    const adminDropdown = () => (
        <DropdownMenu title={<HeaderButton title={"ADMIN"} />} char={""} align="left">
            <div className={styles.adminSectionDropdown}>
                <Sections/>
            </div>
        </DropdownMenu>
    );

    const adminNavbar = () => (
        <>
            {serverDropdown()}
            {adminDropdown()}
            <div className={styles.headerSpacerButton}/>
            <HeaderButton title={"ERENBLAZE"} domain={"www"} link={"/erenblaze"}/>
            {helpDropdown()}
        </>
    );

    const getNavbar = () => {
        let subdomain = getSubDomain(window.location.hostname);
        switch (subdomain.toLowerCase()) {
            case "admin":
                return adminNavbar();
            case "reports":
                return reportsNavbar();
            default:
                return webNavbar();
        }
    };

    return (
        <>
            <div className={styles.headerSpacer}></div>
            <div className={styles.headerContainer}>
                <div className={styles.headerContent}>
                    <div className={styles.headerButtons}>
                        {getNavbar()}
                    </div>
                </div>
                <div className={styles.headerLogoWrapper}>
                    <HeaderLogo/>
                </div>
                <div className={styles.accountHeaderSection}>
                    <AccountHeader/>
                </div>
            </div>
        </>
    );
};

export default Header;